import { useDashboardAudience } from './dashboardAudience'
import { useSearchParams } from 'react-router-dom'

export function portalEventListParams(source: URLSearchParams, csv = false) {
  const params = new URLSearchParams()
  if (source.get('q')) params.set('q', source.get('q')!)
  const sorts = ['date:desc', 'date:asc', 'places:desc', 'places:asc']
  const sort = source.get('sort') ?? 'date:desc'
  params.set('sort', sorts.includes(sort) ? sort : 'date:desc')
  for (const key of ['when', 'year']) {
    const values = (source.get(key) ?? '')
      .split(',')
      .filter((value) =>
        key === 'when' ? ['upcoming', 'past'].includes(value) : /^\d{4}$/.test(value),
      )
    if (values.length) params.set(key, [...new Set(values)].join(','))
  }
  if (!csv && source.get('cursor')) params.set('cursor', source.get('cursor')!)
  return params
}
export function usePortalEventListState(organizationId: number) {
  const [source, setSource] = useSearchParams()
  const params = portalEventListParams(source)
  const base = `${useDashboardAudience(organizationId).base}/event_registrations`
  const update = (key: string, value: string) => {
    const next = new URLSearchParams(source)
    next.delete('cursor')
    if (value) next.set(key, value)
    else next.delete(key)
    setSource(next)
  }
  const clear = () => {
    const next = new URLSearchParams(source)
    for (const key of ['q', 'when', 'year', 'cursor']) next.delete(key)
    setSource(next)
  }
  return {
    params,
    update,
    clear,
    path: `${base}?${params}`,
    csvPath: `${base}.csv?${portalEventListParams(source, true)}`,
  }
}
